import { api } from '@/api/client';

/** One open "Projectmap aanmaken" task (API projectmap/queue.ts). */
export interface ProjectmapQueueRow {
  taskId: number;
  projectId: number;
  projectName: string;
  assigned: boolean;
  saleOrderId: number | null;
  saleOrderName: string | null;
  saleOrderProjectName: string | null;
  clientOrderRef: string | null;
  klant: string | null;
  projectleider: string | null;
  saleOrderLinkMismatch: boolean;
  sNumbers: string[];
  createdAt: string | null;
  cacheState: 'empty' | 'project' | 'sale_order' | 'both' | 'field_missing';
  sharepointUrl: string | null;
  projectOdooUrl: string;
  saleOrderOdooUrl: string | null;
}

export interface ProjectmapQueue {
  rows: ProjectmapQueueRow[];
  cacheFieldAvailable: boolean;
  excludedTemplates: number;
}

export interface SharepointFolder {
  name: string;
  webUrl: string;
  path: string;
}

export type OfferteOutcome = 'found' | 'ambiguous' | 'none' | 'incomplete' | 'unavailable';

export interface OfferteLookup {
  outcome: OfferteOutcome;
  folder: SharepointFolder | null;
  candidates: SharepointFolder[];
  candidateCount: number;
  tier: 'snummer' | 'naam' | 'werf' | null;
  /** False when a year could not be listed: absence is then not proven. */
  complete: boolean;
  searchedYears: number[];
}

export type ScanOutcome = 'found' | 'cached' | 'none' | 'incomplete' | 'unresolved';

export interface ProjectFolderScan {
  outcome: ScanOutcome;
  folder: SharepointFolder | null;
  cachedUrl: string | null;
  discoveryComplete: boolean;
}

export type FolderNameProblem = 'geen_snummer' | 'geen_jaar' | 'geen_werf' | 'geen_klant';

export interface FolderNamePreview {
  name: string | null;
  path: string | null;
  year: number | null;
  sNumber: string | null;
  shortened: { werf: boolean; klant: boolean };
  cleaned: boolean;
  problems: FolderNameProblem[];
}

export interface ProjectmapDetail {
  projectId: number;
  saleOrderName: string | null;
  werf: string | null;
  klant: string | null;
  saleOrderConfirmed: boolean;
  preview: FolderNamePreview;
  offerte: OfferteLookup;
  projectFolder: ProjectFolderScan;
}

export function fetchProjectmapQueue(): Promise<ProjectmapQueue> {
  return api<ProjectmapQueue>('/api/projectmap/queue');
}

export function fetchProjectmapDetail(projectId: number): Promise<ProjectmapDetail> {
  return api<ProjectmapDetail>(`/api/projectmap/detail/${projectId}`);
}
